// Library Class
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
// Class
import { MasterConstants } from '../../../../common/constants/master-constants';
import { FilterOption } from '../../../../common/components/filter/filter-model';
import { ControlType } from '../../../../common/components/filter/filter-enum';
import { CommonService } from './../../../../services/common/common.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
// Service Class
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { ExcelService } from './../../../../services/infrastructure/excel.service';
import { PlotSeedService } from '../../../../services/seed/plot-seed.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-plot-seed-landing',
  templateUrl: './plot-seed-landing.component.html',
  styleUrl: './plot-seed-landing.component.scss'
})
export class PlotSeedLandingComponent implements OnInit, AfterViewInit, OnDestroy {
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  validateEvolveData: any;
  ddlAccounts: any[] = [];
  userMenuAccessList: any;
  readOnlyAccess = false;
  editFullAccess = false;
  filterOptionsData: Array<FilterOption>;
  showCreateButton = false;
  productLineDateSetupList: any;
  isUserSalesManager = false;
  isEvolveAccountRestriction = false;
  subscription = new Subscription();
  masterConstants = MasterConstants;
  plotSeedDataSource: MatTableDataSource<any>;
  @ViewChild('plotSeedTable', { read: MatSort }) plotSeedSort: MatSort;
  @ViewChild('plotSeedPaginator', { read: MatPaginator }) plotSeedPaginator: MatPaginator;
  plotSeedOrderColumns: string[] = [];
  filter: PlotSeedLandingFilterVM = new PlotSeedLandingFilterVM();
  statusList: any = ['ORDER CREATED', 'SUBMITTED', 'CANCELLED', 'ERROR', 'SHIPPED'];
  cropTypeList: any[] = [];

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    public excelService: ExcelService,
    private datePipe: DatePipe,
    private commonService: CommonService,
    private plotSeedService: PlotSeedService,
    private toastrService: ToastrService,
  ) { }

  createNewOrder() {
    this.router.navigate(['/plot-seed/plot-seed-create-order']);
  }

  // ngOnInit
  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      const sessionData = validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.PLOT_SEED)) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.PLOT_SEED, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          this.editFullAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.PLOT_SEED, MasterConstants.USER_ACCESS.EDIT_FULL, this.userMenuAccessList);

          if (this.headerYear) {
            this.setFilterAndGridColumn();
            this.setDefaultFilter();
            this.getGridData(true);
          }
          if (this.headerYear && this.headerCompany) {
            this.subscription.add(
              this.plotSeedService.checkCreateAccessForPlotSeed().subscribe((response) => {
                if (response && this.editFullAccess) {
                  this.showCreateButton = true;
                }
                else {
                  this.showCreateButton = false;
                }
              })
            );
          }
        }
        else {
          this.router.navigate(['/cc/landing-data']);
        }
      }
    }
  }


  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setPlotSummaryTableHeight();
  }


  // set account table height
  setPlotSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.mat-mdc-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 300;
      $('.activeReturnRequest').css('max-height', templateHeight + 'px');
    }, 100);
  }

  // Set Filter and Grid Columns
  setFilterAndGridColumn() {
    this.filterOptionsData = [
      { label: 'Sales Manager Account', key: 'salesManagerAccountNumberList', controlType: ControlType.Text },
      { label: 'Sales Manager Name', key: 'salesManagerAccountNameList', controlType: ControlType.Text },
      { label: 'Account Name', key: 'accountNameList', controlType: ControlType.Text },
      { label: 'Account Number', key: 'accountNumberList', controlType: ControlType.Text },
      { label: 'Parent Account Number', key: 'parentAccountNumberList', controlType: ControlType.Text },
      { label: 'Parent Name', key: 'parentAccountNameList', controlType: ControlType.Text },
      { label: 'Order Number', key: 'orderHeaderIdList', controlType: ControlType.Text },
      { label: 'Product Line', key: 'cropTypeCode', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', isMultiSelect: true },
      { label: 'Hybrid Varierty', key: 'brandList', controlType: ControlType.Text },
      { label: 'Maturity', key: 'maturity', controlType: ControlType.MultiDropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', isMultiSelect: false },
      { label: 'Status', key: 'status', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', isMultiSelect: true },
    ];
    this.plotSeedOrderColumns = ['orderHeaderID', 'salesManagerAccountNumber', 'salesManagerAccountName', 'shipToAccount', 'accountName', 'parentAccountNumber', 'parentName', 'productLine', 'brand', 'marketingBrand', 'maturity', 'orderDate', 'orderQty', 'status'];
  }

  // Set Drop down values for filter
  setDropDownValues() {
    this.subscription.add(this.plotSeedService.getPlotSeedProductLines().subscribe((result: any[]) => {
      this.cropTypeList = result && result.length > 0
        ? [
          { id: '', value: 'Select All' },
          ...result.map(item => ({
            id: item.id,
            value: `${item.value}`
          }))
        ]
        : [];

      this.filterOptionsData.find(x => x.key === 'cropTypeCode').controlData = this.cropTypeList;
    }));
    this.subscription.add(this.plotSeedService.getMaturityData().subscribe((result: any[]) => {
      this.cropTypeList = result && result.length > 0 ? result.map(item => ({
        id: item.id,
        value: `${item.id}`
      })) : [];
      this.filterOptionsData.find(x => x.key === 'maturity').controlData = this.cropTypeList;
    }));
    this.subscription.add(this.plotSeedService.getPlotSeedOrderDateSetupData().subscribe((result: any) => {
      if (result) {
        this.isUserSalesManager = result.isUserSalesManager;
        this.productLineDateSetupList = result.productLineDateSetupList;
      }
    }));
    
    const statuses = [...new Set(this.plotSeedDataSource.data.map(x => x.status))];
    // ['ORDER CREATED', 'SUBMITTED', 'CANCELLED', 'ERROR', 'SHIPPED'];

    this.filterOptionsData.find(x => x.key === 'status').controlData = statuses.map(status => ({
      id: status,
      value: status
    }));
  }


  //getcropTypeList(source) {
  //  let result = [];
  //  const seen = new Set();
  //  for (const item of source) {
  //    if (!seen.has(item.cropTypeCode)) {
  //      seen.add(item.cropTypeCode);
  //      result.push({ id: item.cropTypeCode, value: item.cropTypeDesc });
  //    }
  //  }
  //  result = result.sort((a, b) => a.value.localeCompare(b.value));
  //  return result;
  //}

  // Set default filter values
  setDefaultFilter() {
    this.filter = {
      salesManagerAccountNumberList: null,
      salesManagerAccountNameList: null,
      orderHeaderIdList: null,
      accountNumberList: null,
      accountNameList: null,
      parentAccountNumberList: null,
      parentAccountNameList: null,
      cropTypeCode: null,
      brandList: null,
      maturity: null,
      Status: null
    };
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // get data for both tabs
  getGridData(isfirstimeload: boolean) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.plotSeedService.getPlotSeedLandingData(this.filter).subscribe((result: any[]) => {
      const plotSeedOrderList = result && result.length > 0 ? result : [];
      this.plotSeedDataSource = new MatTableDataSource(plotSeedOrderList);
      if (isfirstimeload) {
        this.setDropDownValues();
      }
      this.plotSeedDataSource.paginator = this.plotSeedPaginator;
      this.plotSeedDataSource.paginator.firstPage();
      this.plotSeedDataSource.sort = this.plotSeedSort;
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  // Search Action
  filterSearchClick(event) {
    this.filter = event;
    this.getGridData(false);
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.filter = event;
    this.getGridData(false);
  }

  // Navigate to selected order detail
  navigateOrderDetail(obj: any) {
    if (obj) {
      if (obj.productLine && this.isUserSalesManager && this.CheckforProductLineSetup(obj.productLine)) {
        this.toastrService.error('Ordering Period has closed.');
        return;
      }
      this.loaderService.setLoaderStatus(true);
      this.plotSeedService.setPlotSeedOrderId(+obj.orderHeaderID);
      this.router.navigate(['plot-seed/plot-seed-create-order']);
      this.loaderService.setLoaderStatus(false);
    }
  }

  CheckforProductLineSetup(productLineId) {
    const item = this.productLineDateSetupList
      ?.find(x => x.data === productLineId);
    if (item?.value === 'N') {
      return true;
    }
    return false;
  }

  public export() {
    this.loaderService.setLoaderStatus(true); // Show loader immediately

    this.subscription.add(this.plotSeedService
      .exportToExcel(this.filter)
      .subscribe(
        (result) => {
          if (result) {

            this.plotSeedService.base64toFile(result.base64, result.mimeType, result.fileName);
            this.loaderService.setLoaderStatus(false);
          }
          else {
            this.loaderService.setLoaderStatus(false);
            this.toastrService.error("An error occurred during export.");
          }
        },
        (error) => this.toastrService.error("An error occurred during export.")
      ));
  }
}
export class PlotSeedLandingFilterVM {
  salesManagerAccountNumberList: number;
  salesManagerAccountNameList: any;
  orderHeaderIdList: number;
  accountNumberList: number;
  accountNameList: any;
  parentAccountNumberList: number;
  parentAccountNameList: any;
  cropTypeCode: string;
  brandList: string;
  maturity: any;
  Status: string;
}
